var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"color":"indigo","app":""}},[_c('span',{staticClass:"white--text"},[_vm._v("© 2020 DigitalizeIT GmbH")])])}
var staticRenderFns = []

export { render, staticRenderFns }